(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"));
	else if(typeof define === 'function' && define.amd)
		define(["react"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("react")) : factory(root["react"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_1__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var lastTime = performance.now();

var myCSS = "\n@keyframes typing-effect-react {\n  0% {\n    opacity: 0;\n  }\n  50% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n\n@-moz-keyframes typing-effect-react {\n  0% {\n    opacity: 0;\n  }\n  50% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n\n@-webkit-keyframes typing-effect-react {\n  0% {\n    opacity: 0;\n  }\n  50% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n\n@-ms-keyframes typing-effect-react {\n  0% {\n    opacity: 0;\n  }\n  50% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n\n@-o-keyframes typing-effect-react {\n  0% {\n    opacity: 0;\n  }\n  50% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n}";

var TypeEffect = function (_Component) {
  _inherits(TypeEffect, _Component);

  function TypeEffect() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, TypeEffect);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TypeEffect.__proto__ || Object.getPrototypeOf(TypeEffect)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      output: ""
    }, _this.index = 0, _this.rafRef = null, _this.timeoutRef = null, _this.animationManager = function () {
      // register the very first rAF which will start the animation off
      _this.rafRef = requestAnimationFrame(function (time) {
        // start the typing animation to animate the currently indexed word
        _this.typeEffect(time, _this.props.data[_this.index], function () {
          // typing animation finished, time to start removal animation
          // but first make a pause
          _this.timeoutRef = setTimeout(function () {
            _this.rafRef = requestAnimationFrame(function (time) {
              _this.deleteEffect(time, function () {
                // removal animation finished, which completes the current animation cycle...
                // so make a pause here & start the next animation cycle
                _this.timeoutRef = setTimeout(function () {
                  // if on last element, then go back to the first one, else go to the next one
                  _this.index = _this.index === _this.props.data.length - 1 ? 0 : _this.index + 1;
                  // start again...
                  _this.animationManager();
                }, _this.props.pauseBeforeRestarting);
              });
            });
          }, _this.props.pauseBeforeDeleting);
        });
      });
    }, _this.typeEffect = function (time, text, callback) {
      // skip animation if the desired number of ms haven't elapsed
      if (time - lastTime < _this.props.typingSpeed) {
        _this.rafRef = requestAnimationFrame(function (time) {
          _this.typeEffect(time, text, callback);
        });
        return;
      }
      lastTime = time;
      // add the next character to output
      _this.setState({
        output: text.substr(0, _this.state.output.length + 1)
      });
      // if more characters left to type out,
      // then register a call to yourself again to take care of the next character, and so on...
      if (_this.state.output.length < text.length) {
        _this.rafRef = requestAnimationFrame(function (time) {
          _this.typeEffect(time, text, callback);
        });
      } else {
        // if no characters left to type, i.e. all been typed out
        // then let the caller know
        callback();
      }
    }, _this.deleteEffect = function (time, callback) {
      // skip animation if the desired number of ms haven't elapsed
      if (time - lastTime < _this.props.typingSpeed) {
        _this.rafRef = requestAnimationFrame(function (time) {
          _this.deleteEffect(time, callback);
        });
        return;
      }
      lastTime = time;
      // remove the next character from output
      _this.setState({
        output: _this.state.output.substr(0, _this.state.output.length - 1)
      });
      // if more characters left to delete,
      // then register a call to yourself again to take care of the next character, and so on...
      if (_this.state.output.length !== 0) {
        _this.rafRef = requestAnimationFrame(function (time) {
          _this.deleteEffect(time, callback);
        });
      } else {
        // if no characters left to delete, i.e. all been deleted
        // then let the caller know
        callback();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(TypeEffect, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      var exists = document.head.querySelectorAll("[data-typing-effect-react]");

      if (!exists.length) {
        var styleElement = document.createElement("style");
        styleElement.setAttribute("data-typing-effect-react", "true");
        document.head.appendChild(styleElement);
        styleElement.textContent = myCSS;
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      // kick the animation off
      this.animationManager();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // cleanup
      if (this.timeoutRef) clearTimeout(this.timeoutRef);
      if (this.rafRef) cancelAnimationFrame(this.rafRef);
    }
  }, {
    key: "render",
    value: function render() {
      var blinkingStyles = {
        WebkitAnimation: "1s typing-effect-react step-end infinite",
        MozAnimation: "1s typing-effect-react step-end infinite",
        MsAnimation: "1s typing-effect-react step-end infinite",
        OAnimation: "1s typing-effect-react step-end infinite",
        animation: "1s typing-effect-react step-end infinite"
      };

      return _react2.default.createElement(
        "span",
        { className: this.props.className, style: this.props.style },
        this.state.output,
        _react2.default.createElement(
          "span",
          { style: blinkingStyles },
          "|"
        )
      );
    }
  }]);

  return TypeEffect;
}(_react.Component);

TypeEffect.defaultProps = {
  typingSpeed: 32, // frame delay period between each character
  deletingSpeed: 32, // frame delay period between each character
  pauseBeforeRestarting: 1000,
  pauseBeforeDeleting: 1500,
  data: [],
  style: {},
  className: null
};

exports.default = TypeEffect;

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_1__;

/***/ })
/******/ ]);
});